import React, { useRef, useState } from 'react';
import ThumbnailsListRenderer from './thumbnailsListRenderer';
import FullImageRenderer from './fullImageRenderer';
import 'components/commandpanel/Layers/LayerView.scss';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import { useContainerFocus } from 'CustomHooks/useContainerFocus';

interface Props {}

const ImagesRenderer = (props: Props) => {
  const {} = props;
  const [selectedTab, setSelectedTab] = useState('thumbnail');
  const containerRef = useRef(null);
  const [isFocused] = useContainerFocus(containerRef);
  const tabComponents: ITabItem[] = [
    {
      title: 'Thumbnail',
      eventKey: 'thumbnail',
      content: <ThumbnailsListRenderer isFocused={isFocused} />,
    },
    {
      title: 'Full Image',
      eventKey: 'fullImage',
      content: selectedTab === 'fullImage' && <FullImageRenderer />,
    },
  ];

  return (
    <div id='imagesrenderer-wrapper' ref={containerRef} className="flex flex-column h-[100%] w-full">
      <RMTabs
        tabItems={tabComponents}
        defaultActiveKey={'thumbnail'}
        id={'imagesrenderer-wellScoreSortbyTab'}
        onSelect={(x) => setSelectedTab(x)}
      />
    </div>
  );
};

export default ImagesRenderer;
